/* ATN Membership - Section 05: Business Opportunities scroller */
/* Arrows-only scroller with native touch swipe. No drag handlers so that
   linked cards keep working. Re-inits on Shopify section load. */
(function () {
  function AtnMemOpp(root) {
    if (!root || root.dataset.oppInit === '1') return;
    root.dataset.oppInit = '1';

    var viewport = root.querySelector('[data-opp-viewport]');
    var prev = root.querySelector('[data-opp-prev]');
    var next = root.querySelector('[data-opp-next]');
    if (!viewport) return;

    function gap() {
      var g = parseInt(getComputedStyle(viewport).columnGap, 10);
      return isNaN(g) ? 0 : g;
    }

    function step() {
      var card = viewport.querySelector('.atn-mem-opp-card');
      if (!card) return Math.round(viewport.clientWidth * 0.8);
      return Math.round(card.getBoundingClientRect().width + gap());
    }

    function update() {
      var max = viewport.scrollWidth - viewport.clientWidth - 1;
      var x = viewport.scrollLeft;
      if (prev) prev.toggleAttribute('disabled', x <= 0);
      if (next) next.toggleAttribute('disabled', x >= max);
    }

    if (prev) {
      prev.addEventListener('click', function () {
        viewport.scrollBy({ left: -step(), behavior: 'smooth' });
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        viewport.scrollBy({ left: step(), behavior: 'smooth' });
      });
    }

    viewport.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-atn-mem-opp]').forEach(AtnMemOpp);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[data-atn-mem-opp]');
    if (el) AtnMemOpp(el);
  });
})();